(function () {
    'use strict'
  
    angular.module('MktzapApp.Controllers').controller('ShowPartnerCompaniesController', ShowPartnerCompaniesController)
  
    ShowPartnerCompaniesController.$inject = ['$rootScope', 'CompanyService', 'NotificationService']
  
    function ShowPartnerCompaniesController ($rootScope, CompanyService, NotificationService) {
      $rootScope.getPageLabels('menu.config.partnerCompanies')
  
      var vmShowPartnerCompaniesCtrl = this
  
      CompanyService
        .loadMetadata()
        .$promise
        .then(function (data) {
            vmShowPartnerCompaniesCtrl.metadata = data
  
            if (!('partner_companies' in vmShowPartnerCompaniesCtrl.metadata.allow)) {
                vmShowPartnerCompaniesCtrl.metadata.allow.partner_companies = false
            }
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.errorLoadMeta)
        })
  
        vmShowPartnerCompaniesCtrl.enable = function () {
            CompanyService
            .saveMetadata(vmShowPartnerCompaniesCtrl.metadata)
            .$promise
            .then(function (data) {
                $rootScope.company_metadata = data
                NotificationService.successHandler(data, $rootScope.labels.saveConfig)
            })
            .catch(function (error) {
                NotificationService.errorHandler(error, $rootScope.labels.errorConfig)
            })
        }
    }
})();